// // LearningContext.js
// import React, { createContext, useContext, useState } from 'react';

// // Create the context
// const IDsContext = createContext();

// // Create a provider component
// export const IDsProvider = ({ children }) => {
//     const [courseID, setCourseID] = useState(null);
//     const [lessonID, setLessonID] = useState(null);
//     const [moduleID, setModuleID] = useState(null);
//     const [vendorID, setVendorID] = useState(null);

//     // Set all IDs at once
//     const setAllIDs = (course, lesson, module, vendor) => {
//         setCourseID(course);
//         setLessonID(lesson);
//         setModuleID(module);
//         setVendorID(vendor);
//     };

//     // Reset all IDs
//     const resetIDs = () => {
//         setCourseID(null);
//         setLessonID(null);
//         setModuleID(null);
//         setVendorID(null);
//     };

//     // Value object to be provided to consumers
//     const value = {
//         courseID,
//         lessonID,
//         moduleID,
//         vendorID,
//         setCourseID,
//         setLessonID,
//         setModuleID,
//         setAllIDs,
//         setVendorID,
//         resetIDs
//     };

//     return (
//         <IDsContext.Provider value={value}>
//             {children}
//         </IDsContext.Provider>
//     );
// };

// // Custom hook for using the context
// export const useIDsContext = () => {
//     const context = useContext(IDsContext);
//     if (context === undefined) {
//         throw new Error('useLearning must be used within a LearningProvider');
//     }
//     return context;
// };

// LearningContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

// Create the context
const IDsContext = createContext();

// Create a provider component
export const IDsProvider = ({ children }) => {
  // Initialize state from localStorage if available
  const [courseID, setCourseID] = useState(() => {
    const saved = localStorage.getItem("ids_courseID");
    return saved !== null ? saved : null;
  });

  const [lessonID, setLessonID] = useState(() => {
    const saved = localStorage.getItem("ids_lessonID");
    return saved !== null ? saved : null;
  });

  const [moduleID, setModuleID] = useState(() => {
    const saved = localStorage.getItem("ids_moduleID");
    return saved !== null ? saved : null;
  });

  const [vendorID, setVendorID] = useState(() => {
    const saved = localStorage.getItem("ids_vendorID");
    return saved !== null ? saved : null;
  });

  const [collegeID, setCollegeID] = useState(() => {
    const saved = localStorage.getItem("ids_collegeID");
    return saved !== null ? saved : null;
  });

  const [vendorName, setVendorName] = useState(() => {
    const saved = localStorage.getItem("ids_vendorName");
    return saved !== null ? saved : null;
  });

  const [courseCount, setCourseCount] = useState(() => {
    const saved = localStorage.getItem("ids_courseCount");
    return saved !== null ? saved : null;
  });

  // Update localStorage when state changes
  useEffect(() => {
    if (courseID !== null) localStorage.setItem("ids_courseID", courseID);
    else localStorage.removeItem("ids_courseID");
  }, [courseID]);

  useEffect(() => {
    if (lessonID !== null) localStorage.setItem("ids_lessonID", lessonID);
    else localStorage.removeItem("ids_lessonID");
  }, [lessonID]);

  useEffect(() => {
    if (moduleID !== null) localStorage.setItem("ids_moduleID", moduleID);
    else localStorage.removeItem("ids_moduleID");
  }, [moduleID]);

  useEffect(() => {
    if (vendorID !== null) localStorage.setItem("ids_vendorID", vendorID);
    else localStorage.removeItem("ids_vendorID");
  }, [vendorID]);

  useEffect(() => {
    if (collegeID !== null) localStorage.setItem("ids_collegeID", collegeID);
    else localStorage.removeItem("ids_collegeID");
  }, [collegeID]);

  useEffect(() => {
    if (vendorName !== null) localStorage.setItem("ids_vendorName", vendorName);
    else localStorage.removeItem("ids_vendorName");
  }, [vendorName]);

  useEffect(() => {
    if (courseCount !== null) localStorage.setItem("ids_courseCount", courseCount);
    else localStorage.removeItem("ids_courseCount");
  }, [courseCount]);

  // Set all IDs at once
  const setAllIDs = (course, lesson, module, vendor, college, vendorName) => {
    setCourseID(course);
    setLessonID(lesson);
    setModuleID(module);
    setVendorID(vendor);
    setCollegeID(college);
    setVendorName(vendorName);
  };

  // Reset all IDs
  const resetIDs = () => {
    setCourseID(null);
    setLessonID(null);
    setModuleID(null);
    setVendorID(null);
    setCollegeID(null);
    setVendorName(null);
    localStorage.removeItem("ids_courseID");
    localStorage.removeItem("ids_lessonID");
    localStorage.removeItem("ids_moduleID");
    localStorage.removeItem("ids_vendorID");
    localStorage.removeItem("ids_collegeID");
    localStorage.removeItem("ids_vendorName");
  };

  // Value object to be provided to consumers
  const value = {
    courseID,
    lessonID,
    moduleID,
    vendorID,
    collegeID,
    vendorName,
    courseCount,
    setCourseID,
    setLessonID,
    setModuleID,
    setVendorID,
    setCollegeID,
    setVendorName,
    setAllIDs,
    resetIDs,
    setCourseCount
  };

  return <IDsContext.Provider value={value}>{children}</IDsContext.Provider>;
};

// Custom hook for using the context
export const useIDsContext = () => {
  const context = useContext(IDsContext);
  if (context === undefined) {
    throw new Error("useIDsContext must be used within an IDsProvider");
  }
  return context;
};
